import { type TranslationTree } from '@/i18n/types';

export const messages = {
  error: 'Não foi possível reenviar o e-mail de ativação',
} satisfies TranslationTree;
